import { define } from './define';

// The pieces page (grid, board and list), its toolbar and bulk actions, and the "new piece" dialog.
export const pieces = define({
  es: {
    'pieces.title': 'Piezas',
    'pieces.new': 'Nueva pieza',
    'pieces.toolbar': 'Herramientas de la lista',
    'pieces.search': 'Buscar piezas…',
    'pieces.searchLabel': 'Buscar piezas por título o campaña (atajo: /)',
    'pieces.searchTip': 'Buscar por título o campaña',
    'pieces.summary': { one: '{count} pieza', other: '{count} piezas' },
    'pieces.summaryOf': { one: '{count} de {total} piezas', other: '{count} de {total} piezas' },
    'pieces.summaryWaiting': { one: '{count} espera revisión', other: '{count} esperan revisión' },

    'pieces.view.label': 'Vista',
    'pieces.view.grid': 'Rejilla',
    'pieces.view.board': 'Tablero',
    'pieces.view.list': 'Lista',

    'pieces.look.title': 'Apariencia',
    'pieces.look.note': 'Solo lo ves tú',
    'pieces.look.size': 'Tamaño',
    'pieces.look.aspect': 'Proporción',
    'pieces.look.aspect.169': 'Horizontal, 16:9',
    'pieces.look.aspect.11': 'Cuadrada, 1:1',
    'pieces.look.aspect.45': 'Vertical, 4:5',
    'pieces.look.thumb': 'Miniatura',
    'pieces.look.fit': 'Encajar',
    'pieces.look.fill': 'Llenar',
    'pieces.look.info': 'Datos de la tarjeta',

    'pieces.filter.state': 'Filtrar por estado',
    'pieces.filter.stateShort': 'Estado:',
    'pieces.filter.allStates': 'todos',
    'pieces.filter.allStatesLong': 'Todos los estados',
    'pieces.filter.network': 'Filtrar por red',
    'pieces.filter.networkShort': 'Red:',
    'pieces.filter.allNetworks': 'todas',
    'pieces.filter.allNetworksLong': 'Todas las redes',
    'pieces.filter.noNetworks': 'Nada programado ni publicado todavía.',
    'pieces.filter.crumb.draft': 'Borradores',
    'pieces.filter.crumb.in_review': 'Por revisar',
    'pieces.filter.crumb.changes_requested': 'Cambios pedidos',
    'pieces.filter.crumb.approved': 'Aprobadas',
    'pieces.filter.crumb.scheduled': 'Programadas',
    'pieces.filter.crumb.published': 'Publicadas',
    'pieces.filter.crumb.discarded': 'Descartadas',

    'pieces.sort.label': 'Ordenar por',
    'pieces.sort.short': 'Ordenar:',
    'pieces.sort.updated': 'Última versión',
    'pieces.sort.target': 'Fecha objetivo',
    'pieces.sort.title': 'Título',
    'pieces.sort.asc': 'Ascendente',
    'pieces.sort.desc': 'Descendente',

    'pieces.when.now': 'ahora',
    'pieces.when.today': 'hoy, {time}',
    'pieces.when.tomorrow': 'mañana, {time}',

    'pieces.card.select': 'Seleccionar «{title}»',
    'pieces.card.selectHint': 'Seleccionar (Mayús para un rango, ⌘A para todo)',
    'pieces.card.menu': 'Más acciones para «{title}»',
    'pieces.card.menuShort': 'Más acciones',
    'pieces.card.version': 'Versión {number}',
    'pieces.card.comments': { one: '{count} comentario abierto', other: '{count} comentarios abiertos' },
    'pieces.card.noVersion': 'Sin versiones todavía',
    'pieces.card.noPreview': 'Sin vista previa',
    'pieces.card.created': 'Creada {when}',
    'pieces.card.video': 'Vídeo',
    'pieces.card.image': 'Imagen',
    'pieces.card.images': '{count} imág.',
    'pieces.card.pdf': 'PDF',
    'pieces.card.pdfFiles': 'PDF · {count}',
    'pieces.card.nextTitle': 'Próxima publicación: {when}, en {network}',
    'pieces.card.byAgent': 'La última versión es del agente',

    'pieces.menu.open': 'Abrir',
    'pieces.menu.review': 'Revisar la versión {number}',
    'pieces.menu.schedule': 'Programar…',
    'pieces.menu.move': 'Mover a campaña…',
    'pieces.menu.discard': 'Descartar…',
    'pieces.menu.discardLocked': 'Tiene una versión aprobada o algo programado: la descarta quien aprueba.',

    'pieces.sel.label': 'Piezas seleccionadas',
    'pieces.sel.count': { one: '{count} pieza seleccionada', other: '{count} piezas seleccionadas' },
    'pieces.sel.clear': 'Quitar la selección (Esc)',
    'pieces.sel.clearTip': 'Quitar la selección',
    'pieces.sel.download': 'Descargar',
    'pieces.sel.downloadHint': 'Los archivos de la última versión de cada una',
    'pieces.sel.move': 'Mover a…',
    'pieces.sel.discard': 'Descartar',
    'pieces.sel.schedule': 'Programar',
    'pieces.download.started': { one: 'Descargando {count} archivo', other: 'Descargando {count} archivos' },
    'pieces.download.nothing': 'Las piezas elegidas no tienen archivos todavía.',

    'pieces.move.title': { one: 'Mover a una campaña', other: 'Mover {count} piezas a una campaña' },
    'pieces.move.none': 'Sin campaña',
    'pieces.move.current': 'Está aquí',
    'pieces.move.done': { one: 'Movida a «{campaign}»', other: '{count} piezas movidas a «{campaign}»' },
    'pieces.move.doneNone': { one: 'Ya no está en ninguna campaña', other: '{count} piezas fuera de campaña' },
    'pieces.move.empty': 'Esta marca no tiene campañas todavía: créalas con el «+» de Piezas, en la barra lateral.',

    'pieces.discard.title': { one: 'Descartar la pieza', other: 'Descartar {count} piezas' },
    'pieces.discard.bodyOne': '«{title}» deja de estar en revisión y ya no se le pueden subir versiones.',
    'pieces.discard.bodyMany': 'Las {count} piezas dejan de estar en revisión y ya no se les pueden subir versiones.',
    'pieces.discard.cancels': { one: 'Una tiene publicaciones pendientes: se cancelan.', other: '{count} tienen publicaciones pendientes: se cancelan.' },
    'pieces.discard.locked': {
      one: '{count} no la puedes descartar tú: tiene una versión aprobada o algo programado, y eso lo decide quien aprueba.',
      other: '{count} no las puedes descartar tú: tienen una versión aprobada o algo programado, y eso lo decide quien aprueba.',
    },
    'pieces.discard.final': 'No se puede deshacer.',
    'pieces.discard.noneYours': {
      one: 'No la puedes descartar tú: tiene una versión aprobada o algo programado, y eso lo decide quien aprueba.',
      other: 'No puedes descartar ninguna de las {count}: tienen una versión aprobada o algo programado, y eso lo decide quien aprueba.',
    },
    'pieces.discard.submit': { one: 'Descartar pieza', other: 'Descartar {count} piezas' },
    'pieces.discard.done': { one: 'Pieza descartada', other: '{count} piezas descartadas' },
    'pieces.discard.failed': { one: 'Una no se pudo descartar: {reason}', other: '{count} no se pudieron descartar: {reason}' },

    'pieces.board.drop': 'Suelta aquí para programar',
    'pieces.board.hint': 'Arrastra una pieza aprobada a «Programada» para programarla',
    'pieces.board.opening': 'Abriendo la programación…',
    'pieces.board.noApproved': 'Esta pieza no tiene una versión aprobada que programar.',
    'pieces.board.empty.draft': 'Nada sin empezar',
    'pieces.board.empty.in_review': 'Nada esperando revisión',
    'pieces.board.empty.changes_requested': 'Nadie ha pedido cambios',
    'pieces.board.empty.approved': 'Nada aprobado sin programar',
    'pieces.board.empty.scheduled': 'Nada programado',
    'pieces.board.empty.published': 'Nada publicado todavía',
    'pieces.board.refuse.notApproved': 'Solo se programa lo aprobado: antes hay que aprobar su última versión.',
    'pieces.board.refuse.cannotSchedule': 'Programar lo hace quien aprueba.',
    'pieces.board.refuse.draft': 'Una pieza es borrador hasta que tiene su primera versión, y no vuelve atrás.',
    'pieces.board.refuse.in_review': 'Una pieza entra en revisión cuando se le sube una versión nueva.',
    'pieces.board.refuse.changes_requested': 'Los cambios se piden en la revisión, con comentarios: abre la pieza y revísala.',
    'pieces.board.refuse.approved': 'Una pieza se aprueba revisando su versión, no moviéndola: abre la pieza y revísala.',
    'pieces.board.refuse.scheduled': 'Solo se programa lo aprobado.',
    'pieces.board.refuse.published': 'Una pieza pasa a publicada cuando sale en una red; eso lo lleva Publicar.',
    'pieces.board.refuse.discarded': 'Para descartar una pieza, usa su menú.',

    'pieces.list.preview': 'Vista previa',
    'pieces.list.title': 'Título',
    'pieces.list.campaign': 'Campaña',
    'pieces.list.state': 'Estado',
    'pieces.list.version': 'Versión',
    'pieces.list.author': 'Autor',
    'pieces.list.comments': 'Comentarios',
    'pieces.list.next': 'Próxima publicación',
    'pieces.list.updated': 'Actualizada',
    'pieces.list.selectAll': 'Seleccionar todas',
    'pieces.list.selectAllHint': 'Seleccionar todas (⌘A)',
    'pieces.list.keys': '↑ ↓ para moverte · Intro abre · Espacio selecciona',

    'pieces.empty.all': 'Todavía no hay piezas.',
    'pieces.empty.campaign': 'Esta campaña no tiene piezas.',
    'pieces.empty.agent': 'Ninguna pieza tiene una versión del agente todavía.',
    'pieces.empty.draft': 'No hay borradores.',
    'pieces.empty.in_review': 'Nada espera revisión.',
    'pieces.empty.changes_requested': 'Ninguna pieza tiene cambios pedidos.',
    'pieces.empty.approved': 'Todavía no hay piezas aprobadas.',
    'pieces.empty.scheduled': 'Nada programado.',
    'pieces.empty.published': 'Todavía no se ha publicado nada.',
    'pieces.empty.discarded': 'No hay piezas descartadas.',
    'pieces.empty.search': 'Nada coincide con «{q}».',
    'pieces.empty.network': 'Nada programado ni publicado en {network}.',
    'pieces.empty.clear': 'Quitar filtros',
    'pieces.empty.seeAll': 'Ver todas',

    'pieces.newTitle': 'Nueva pieza',
    'pieces.field.title': 'Título',
    'pieces.field.kind': 'Tipo',
    'pieces.field.campaign': 'Campaña',
    'pieces.field.noCampaign': 'Sin campaña',
    'pieces.field.brief': 'Brief',
    'pieces.field.target': 'Fecha objetivo (opcional)',
    'pieces.field.source': 'Origen del proyecto (opcional)',
    'pieces.field.sourcePlaceholder': 'videos:2026-09/telenovela',
    'pieces.field.sourceHint': 'Dónde está el material de la pieza, para el agente.',
    'pieces.field.ai': 'Generada con IA',
    'pieces.field.aiHint': 'Lleva la etiqueta de IA en las redes que la tienen.',
    'pieces.kindOption.video': 'Vídeo (Reel, Short, TikTok)',
    'pieces.kindOption.carousel': 'Carrusel',
    'pieces.kindOption.post': 'Post (una imagen)',
    'pieces.kindOption.story': 'Story',
    'pieces.kindOption.pdf': 'Documento PDF',
    'pieces.create': 'Crear pieza',
    'pieces.created': 'Pieza creada',
  },
  en: {
    'pieces.title': 'Pieces',
    'pieces.new': 'New piece',
    'pieces.toolbar': 'List tools',
    'pieces.search': 'Search pieces…',
    'pieces.searchLabel': 'Search pieces by title or campaign (shortcut: /)',
    'pieces.searchTip': 'Search by title or campaign',
    'pieces.summary': { one: '{count} piece', other: '{count} pieces' },
    'pieces.summaryOf': { one: '{count} of {total} pieces', other: '{count} of {total} pieces' },
    'pieces.summaryWaiting': { one: '{count} waiting for review', other: '{count} waiting for review' },

    'pieces.view.label': 'View',
    'pieces.view.grid': 'Grid',
    'pieces.view.board': 'Board',
    'pieces.view.list': 'List',

    'pieces.look.title': 'Appearance',
    'pieces.look.note': 'Only you see this',
    'pieces.look.size': 'Card size',
    'pieces.look.aspect': 'Aspect ratio',
    'pieces.look.aspect.169': 'Landscape, 16:9',
    'pieces.look.aspect.11': 'Square, 1:1',
    'pieces.look.aspect.45': 'Portrait, 4:5',
    'pieces.look.thumb': 'Thumbnail',
    'pieces.look.fit': 'Fit',
    'pieces.look.fill': 'Fill',
    'pieces.look.info': 'Show card info',

    'pieces.filter.state': 'Filter by state',
    'pieces.filter.stateShort': 'State:',
    'pieces.filter.allStates': 'all',
    'pieces.filter.allStatesLong': 'Every state',
    'pieces.filter.network': 'Filter by network',
    'pieces.filter.networkShort': 'Network:',
    'pieces.filter.allNetworks': 'all',
    'pieces.filter.allNetworksLong': 'Every network',
    'pieces.filter.noNetworks': 'Nothing scheduled or published yet.',
    'pieces.filter.crumb.draft': 'Drafts',
    'pieces.filter.crumb.in_review': 'To review',
    'pieces.filter.crumb.changes_requested': 'Changes requested',
    'pieces.filter.crumb.approved': 'Approved',
    'pieces.filter.crumb.scheduled': 'Scheduled',
    'pieces.filter.crumb.published': 'Published',
    'pieces.filter.crumb.discarded': 'Discarded',

    'pieces.sort.label': 'Sort by',
    'pieces.sort.short': 'Sort:',
    'pieces.sort.updated': 'Latest version',
    'pieces.sort.target': 'Target date',
    'pieces.sort.title': 'Title',
    'pieces.sort.asc': 'Ascending',
    'pieces.sort.desc': 'Descending',

    'pieces.when.now': 'just now',
    'pieces.when.today': 'today, {time}',
    'pieces.when.tomorrow': 'tomorrow, {time}',

    'pieces.card.select': 'Select “{title}”',
    'pieces.card.selectHint': 'Select (Shift for a range, ⌘A for all)',
    'pieces.card.menu': 'More actions for “{title}”',
    'pieces.card.menuShort': 'More actions',
    'pieces.card.version': 'Version {number}',
    'pieces.card.comments': { one: '{count} open comment', other: '{count} open comments' },
    'pieces.card.noVersion': 'No versions yet',
    'pieces.card.noPreview': 'No preview',
    'pieces.card.created': 'Created {when}',
    'pieces.card.video': 'Video',
    'pieces.card.image': 'Image',
    'pieces.card.images': '{count} images',
    'pieces.card.pdf': 'PDF',
    'pieces.card.pdfFiles': 'PDF · {count}',
    'pieces.card.nextTitle': 'Next publication: {when}, on {network}',
    'pieces.card.byAgent': 'The latest version is the agent’s',

    'pieces.menu.open': 'Open',
    'pieces.menu.review': 'Review version {number}',
    'pieces.menu.schedule': 'Schedule…',
    'pieces.menu.move': 'Move to campaign…',
    'pieces.menu.discard': 'Discard…',
    'pieces.menu.discardLocked': 'It has an approved version or something scheduled: an approver discards it.',

    'pieces.sel.label': 'Selected pieces',
    'pieces.sel.count': { one: '{count} piece selected', other: '{count} pieces selected' },
    'pieces.sel.clear': 'Clear the selection (Esc)',
    'pieces.sel.clearTip': 'Clear the selection',
    'pieces.sel.download': 'Download',
    'pieces.sel.downloadHint': 'The files of each one’s latest version',
    'pieces.sel.move': 'Move to…',
    'pieces.sel.discard': 'Discard',
    'pieces.sel.schedule': 'Schedule',
    'pieces.download.started': { one: 'Downloading {count} file', other: 'Downloading {count} files' },
    'pieces.download.nothing': 'The chosen pieces have no files yet.',

    'pieces.move.title': { one: 'Move to a campaign', other: 'Move {count} pieces to a campaign' },
    'pieces.move.none': 'No campaign',
    'pieces.move.current': 'It is here',
    'pieces.move.done': { one: 'Moved to “{campaign}”', other: '{count} pieces moved to “{campaign}”' },
    'pieces.move.doneNone': { one: 'No longer in a campaign', other: '{count} pieces out of any campaign' },
    'pieces.move.empty': 'This brand has no campaigns yet: create them with the “+” next to Pieces, in the sidebar.',

    'pieces.discard.title': { one: 'Discard the piece', other: 'Discard {count} pieces' },
    'pieces.discard.bodyOne': '“{title}” leaves review and no more versions can be uploaded to it.',
    'pieces.discard.bodyMany': 'The {count} pieces leave review and no more versions can be uploaded to them.',
    'pieces.discard.cancels': { one: 'One has publications still to go out: they are cancelled.', other: '{count} have publications still to go out: they are cancelled.' },
    'pieces.discard.locked': {
      one: '{count} you cannot discard yourself: it has an approved version or something scheduled, and that is an approver’s call.',
      other: '{count} you cannot discard yourself: they have an approved version or something scheduled, and that is an approver’s call.',
    },
    'pieces.discard.final': 'This cannot be undone.',
    'pieces.discard.noneYours': {
      one: 'You cannot discard it yourself: it has an approved version or something scheduled, and that is an approver’s call.',
      other: 'You cannot discard any of the {count}: they have an approved version or something scheduled, and that is an approver’s call.',
    },
    'pieces.discard.submit': { one: 'Discard piece', other: 'Discard {count} pieces' },
    'pieces.discard.done': { one: 'Piece discarded', other: '{count} pieces discarded' },
    'pieces.discard.failed': { one: 'One could not be discarded: {reason}', other: '{count} could not be discarded: {reason}' },

    'pieces.board.drop': 'Drop here to schedule',
    'pieces.board.hint': 'Drag an approved piece to “Scheduled” to schedule it',
    'pieces.board.opening': 'Opening the schedule…',
    'pieces.board.noApproved': 'This piece has no approved version to schedule.',
    'pieces.board.empty.draft': 'Nothing waiting to start',
    'pieces.board.empty.in_review': 'Nothing waiting for review',
    'pieces.board.empty.changes_requested': 'Nobody asked for changes',
    'pieces.board.empty.approved': 'Nothing approved and unscheduled',
    'pieces.board.empty.scheduled': 'Nothing scheduled',
    'pieces.board.empty.published': 'Nothing published yet',
    'pieces.board.refuse.notApproved': 'Only what is approved can be scheduled: its latest version has to be approved first.',
    'pieces.board.refuse.cannotSchedule': 'Scheduling is for approvers.',
    'pieces.board.refuse.draft': 'A piece is a draft until it has its first version, and it does not go back.',
    'pieces.board.refuse.in_review': 'A piece goes into review when a new version is uploaded to it.',
    'pieces.board.refuse.changes_requested': 'Changes are asked for in the review, with comments: open the piece and review it.',
    'pieces.board.refuse.approved': 'A piece is approved by reviewing its version, not by moving it: open the piece and review it.',
    'pieces.board.refuse.scheduled': 'Only what is approved can be scheduled.',
    'pieces.board.refuse.published': 'A piece becomes published when it goes out on a network; Publish takes care of that.',
    'pieces.board.refuse.discarded': 'To discard a piece, use its menu.',

    'pieces.list.preview': 'Preview',
    'pieces.list.title': 'Title',
    'pieces.list.campaign': 'Campaign',
    'pieces.list.state': 'State',
    'pieces.list.version': 'Version',
    'pieces.list.author': 'Author',
    'pieces.list.comments': 'Comments',
    'pieces.list.next': 'Next publication',
    'pieces.list.updated': 'Updated',
    'pieces.list.selectAll': 'Select all',
    'pieces.list.selectAllHint': 'Select all (⌘A)',
    'pieces.list.keys': '↑ ↓ to move · Enter opens · Space selects',

    'pieces.empty.all': 'No pieces yet.',
    'pieces.empty.campaign': 'This campaign has no pieces.',
    'pieces.empty.agent': 'No piece has a version by the agent yet.',
    'pieces.empty.draft': 'No drafts.',
    'pieces.empty.in_review': 'Nothing is waiting for review.',
    'pieces.empty.changes_requested': 'No piece has changes requested.',
    'pieces.empty.approved': 'No approved pieces yet.',
    'pieces.empty.scheduled': 'Nothing scheduled.',
    'pieces.empty.published': 'Nothing published yet.',
    'pieces.empty.discarded': 'No discarded pieces.',
    'pieces.empty.search': 'Nothing matches “{q}”.',
    'pieces.empty.network': 'Nothing scheduled or published on {network}.',
    'pieces.empty.clear': 'Clear filters',
    'pieces.empty.seeAll': 'See all',

    'pieces.newTitle': 'New piece',
    'pieces.field.title': 'Title',
    'pieces.field.kind': 'Type',
    'pieces.field.campaign': 'Campaign',
    'pieces.field.noCampaign': 'No campaign',
    'pieces.field.brief': 'Brief',
    'pieces.field.target': 'Target date (optional)',
    'pieces.field.source': 'Project source (optional)',
    'pieces.field.sourcePlaceholder': 'videos:2026-09/telenovela',
    'pieces.field.sourceHint': 'Where the piece’s material lives, for the agent.',
    'pieces.field.ai': 'Generated with AI',
    'pieces.field.aiHint': 'Carries the AI label on networks that have one.',
    'pieces.kindOption.video': 'Video (Reel, Short, TikTok)',
    'pieces.kindOption.carousel': 'Carousel',
    'pieces.kindOption.post': 'Post (single image)',
    'pieces.kindOption.story': 'Story',
    'pieces.kindOption.pdf': 'PDF document',
    'pieces.create': 'Create piece',
    'pieces.created': 'Piece created',
  },
});
